<template>
  <div class="ChangePassword">
    <el-card class="box-card">
      <div class="bottom-margin-20">
        <div class="flex">
          <img
            src="../assets/images/myAccount/password-recovery.png"
            style="width: 25px;"
          />
          <div class="label-md-bold-black left-margin-10">Change Password</div>
        </div>
      </div>

      <div>
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div
              class="form-group"
              :class="{
                'not-empty': old_password.length,
                'form-group--error':
                  show_error_on_empty && $v.old_password.$error,
              }"
            >
              <label class="input-label-bold-gray">Old Password</label
              >&nbsp;<span class="required-field">*</span>

              <input
                type="text"
                class="custom-input top-margin-5"
                placeholder="Old password"
                v-model="old_password"
                autocomplete="new-password"
              />
            </div>

            <div class="error" v-if="!$v.old_password.required">
              Field is required
            </div>
          </el-col>
        </el-row>

        <el-row class="top-margin-10">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div
              class="form-group relative"
              :class="{
                'not-empty': new_password.length,
                'form-group--error':
                  show_error_on_empty && $v.new_password.$error,
              }"
            >
              <label class="input-label-bold-gray">New Password</label
              >&nbsp;<span class="required-field">*</span>

              <input
                :type="password_visible ? 'text' : 'password'"
                class="custom-input top-margin-5"
                placeholder="New password"
                v-model="new_password"
                autocomplete="new-password"
              />

              <img
                v-if="password_visible"
                src="../assets/images/visibility.png"
                style="position: absolute; right: 10px; top: 35px; cursor: pointer;"
                @click="password_visible = !password_visible"
              />

              <img
                v-else
                src="../assets/images/eye.png"
                style="position: absolute; right: 10px; top: 35px; cursor: pointer;"
                @click="password_visible = !password_visible"
              />
            </div>

            <div
              style="color: red; font-size: 0.75em;"
              v-if="new_password_regex_error"
            >
              Password must contain :<br />
              1 lowercase letter,<br />
              1 uppercase letter,<br />
              1 special charater (#,$,%,^,*),<br />
              1 number
            </div>

            <div class="error" v-if="!$v.new_password.required">
              Field is required
            </div>
          </el-col>
        </el-row>

        <el-row class="top-margin-10">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div
              class="form-group relative"
              :class="{
                'not-empty': confirm_password.length,
                'form-group--error':
                  show_error_on_empty && $v.confirm_password.$error,
              }"
            >
              <label class="input-label-bold-gray">Confirm Password</label
              >&nbsp;<span class="required-field">*</span>

              <input
                :type="password_visible ? 'text' : 'password'"
                class="custom-input top-margin-5"
                placeholder="Confirm password"
                v-model="confirm_password"
                autocomplete="new-password"
              />

              <img
                v-if="password_visible"
                src="../assets/images/visibility.png"
                style="position: absolute; right: 10px; top: 35px; cursor: pointer;"
                @click="password_visible = !password_visible"
              />

              <img
                v-else
                src="../assets/images/eye.png"
                style="position: absolute; right: 10px; top: 35px; cursor: pointer;"
                @click="password_visible = !password_visible"
              />
            </div>

            <div
              style="color: red; font-size: 0.75em;"
              v-if="password_not_matched_error"
            >
              Confirm password not matching
            </div>

            <div class="error" v-if="!$v.confirm_password.required">
              Field is required
            </div>
          </el-col>
        </el-row>

        <div class="text-right flex-end save-btn-section top-margin-20">
          <div
            class="font-weight-600 external-link-color font-08rem right-margin-15 cursor-pointer"
            @click="goToLink('/data-categorisation')"
            v-if="currentUrl == '/change-password'"
          >
            Skip
          </div>

          <el-button
            type="primary custom-btn"
            :loading="is_password_changing"
            :disabled="
              new_password_regex_error ||
                (!old_password.trim() ||
                  !new_password.trim() ||
                  !confirm_password.trim())
            "
            @click="changePassword()"
            >Save</el-button
          >
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { serverAddr } from "../networkConfig";
import { required } from "vuelidate/lib/validators";
import CripNotice from "crip-vue-notice";
import { updateProfileNetworkCallBack } from "../mixins/UpdateProfile.NetworkCallBack";

export default {
  name: "ChangePassword",
  mixins: [updateProfileNetworkCallBack],

  data() {
    return {
      change_password_collapse: "1",
      old_password: "",
      new_password: "",
      new_password_regex_error: false,
      password_visible: false,
      is_password_changing: false,
      password_not_matched_error: false,
      show_error_on_empty: false,
      confirm_password: "",
      currentUrl: "",
      userProfile: localStorage.getItem("profile")
        ? JSON.parse(localStorage.getItem("profile"))
        : null,
    };
  },

  validations: {
    old_password: {
      required,
    },

    new_password: {
      required,
    },
    confirm_password: {
      required,
    },
  },

  watch: {
    new_password(newValue, oldValue) {
      // let regularExpression = /^(?=.*[a-zA-Z])(?=.*[0-9]).+$/;
      let regularExpression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;

      if (newValue.trim()) {
        if (regularExpression.test(newValue)) {
          this.new_password_regex_error = false;

          if (newValue == this.confirm_password.trim()) {
            this.password_not_matched_error = false;
          } else if (
            this.confirm_password.trim() &&
            newValue != this.confirm_password.trim()
          ) {
            this.password_not_matched_error = true;
          }
        } else {
          this.new_password_regex_error = true;
        }
      } else {
        this.new_password_regex_error = false;
      }
    },
    confirm_password(newValue, oldValue) {
      if (newValue.trim()) {
        if (newValue == this.new_password.trim()) {
          this.password_not_matched_error = false;
        } else if (
          this.new_password.trim() &&
          newValue != this.new_password.trim()
        ) {
          this.password_not_matched_error = true;
        }
      }
    },
  },
  mounted() {
    this.currentUrl = this.$route.path;
  },

  methods: {
    changePassword() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.is_password_changing = true; //displayed loader on btn
        this.show_error_on_empty = true; //Show error on empty

        serverAddr
          .post("/auth/v1/set_new_password", {
            old_password: this.old_password,
            new_password: this.new_password,
          })
          .then((response) => {
            var data = response.data;
            if (data.status) {
              new CripNotice({
                title: "Success",
                description: data.message,
                type: "success",
                duration: 3,
              });

              this.goToLink("/experts-past-recommendations");

              // cleared localstorage and redirected to landing page
              //   localStorage.clear();
              //   this.$router.push("/");
            } else {
              if (data.message == "Old password does not match.") {
                this.old_password = "";
              } else if (
                data.message == "Old password and new password should not same."
              ) {
                this.new_password = "";
                this.confirm_password = "";
              }
              new CripNotice({
                title: "Error",
                description: data.message,
                type: "error",
                duration: 2,
              });
            }

            this.is_password_changing = false; //disabled loader
            this.show_error_on_empty = false; //Show error on empty
          })
          .catch((error) => {
            console.log(error);
            this.is_password_changing = false; //disabled loader
            this.show_error_on_empty = false; //Show error on empty
          });
      }
    },
    changeUserVisitedStatus() {
      serverAddr
        .post("/auth/v1/profile/update", {
          visited_on_change_password_page: false,
        })
        .then((response) => {
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goToLink(link) {
      if (link) {
        this.$router.push(link);
      }
    },
  },

  beforeDestroy() {
    if (this.userProfile.ask_password_for_change) {
      this.changeUserVisitedStatus();
    }
  },
};
</script>

<style scoped lang="scss">
.ChangePassword {
  .box-card {
    padding: 0 20px;
    border-radius: 8px;
  }
  @media screen and (max-width: 400px) {
    .box-card {
      padding: 0;
    }
  }
}
</style>
